<template>
  <div>
    <block :nobody="true" ref="buser" class="soft-control">
      <soft-table
        @rowSelected="tbSetRowSelected"
        @rowClicked="tbRowClicked"
        class="table align-items-center table-flush"
        tbody-classes="list"
        :pending="false"
        :dataTable="productSpecifys"
        :fields="fields"
        :minHeight="$hMainContent - 64"
        :showAll="true"
        :norecordAdd="handleAddNew"
        :noDelete="true"
        @doEditRow="handleEdit"
        :contextMenus="[
          {
            key: 'new',
            icon: 'fa-plus',
            label: 'Thêm mới'
          },
          {
            key: 'spec_feature',
            icon: 'fa-atom',
            label: 'Thông số kỹ thuật'
          },
          {
            key: 'copy',
            icon: 'fa-copy',
            label: 'Copy dòng này'
          },
          {
            key: 'edit',
            icon: 'fa-edit',
            label: 'Chỉnh sửa dòng này'
          },
          {
            key: 'init',
            icon: 'fa-plug',
            label: 'Thêm sản phẩm không qua sản xuất'
          }
        ]"
        @contextMenuItemClick="tbHandleContextMenuItemClick"
        ref="soft-table"
      >
        <template v-slot:cell(name)="{ value, item }">
          <span class="mx-1 text-center">{{ item.id }} - {{ item.unit }}</span>
        </template>
        <template v-slot:cell(unitHank)="{ value, item }">
          <span>{{ value }} {{ $ucWord(item.unit) }}/Cuộn </span>
        </template>
        <template v-slot:cell(unitBag)="{ value, item }">
          <span>{{ value }} {{ $ucWord(item.unit) }}/Bịch </span>
        </template>
        <template v-slot:cell(unitSack)="{ value, item }">
          <span>{{ value }} {{ $ucWord(item.unit) }}/Bao </span>
        </template>
        <template v-slot:cell(quota)="{ value }">
          <span>{{ value }} </span>
        </template>
        <template v-slot:cell(hankBag)="{ value }">
          <span>{{ value }} Cuộn/bịch</span>
        </template>
        <template v-slot:cell(hankSack)="{ value }">
          <span>{{ value }} Cuộn/bao</span>
        </template>
        <template v-slot:cell(bagSack)="{ value }">
          <span>{{ value }} Bịch/bao</span>
        </template>
        <template v-slot:cell(elastic)="{ value }">
          <span>{{ value }}</span>
        </template>

        <template v-slot:cell(userVerify)="{ value }">
          <span v-if="value.id" class="badge badge-success">{{ value.username }}</span>
          <span v-else class="badge badge-danger">Chưa được duyệt</span>
        </template>
        <template v-slot:cell(userManage)="{ value }">
          <span v-if="value.id" class="badge badge-info">{{ value.username }}</span>
          <span v-else class="badge badge-danger">Chưa có người hỗ trợ</span>
        </template>
        <template v-slot:action="{ item }">
          <b-button @click="tbRowHandleFeatureInfo(item)" variant="primary px-1 py-0">
            <i class="fa fa-atom"></i> Thông số kỹ thuật</b-button
          >
        </template>
      </soft-table>
      <div class="p-1">
        <control-mini
          :countChecked="countChecked"
          @doAddNew="handleAddNew"
          @doEdit="handleEdit"
          @search="handleSearch"
          @doDelete="handleDeletes"
          :noDelete="true"
        ></control-mini>
      </div>
    </block>
    <spec-modal ref="specModal" @submit:success="addSpecProductUnit"></spec-modal>
    <spec-feature-modal ref="specFeatureModal"></spec-feature-modal>
    <product-info-modal @reloadProductInfo="$emit('reloadProductInfo')" ref="productInfoModal"></product-info-modal>
  </div>
</template>
<script>
// import { productService } from "@/_services";
import SpecModal from './__SpecModal';
import SpecFeatureModal from './__SpecFeatureModal';
import productInfoModal from './__ProductInfoModal';

export default {
  props: {},
  components: { SpecModal, SpecFeatureModal, productInfoModal },
  data() {
    return {
      productSpecifys: [],
      productSpecifysAll: [],
      fields: [
        {
          variant: 'primary',
          key: 'id',
          class: 'checkbox'
        },
        {
          stickyColumn: true,
          key: 'name',
          label: 'Đơn vị',
          sortable: true
        },
        {
          variant: 'info',
          key: 'unitHank',
          label: 'ĐVT/Cuộn',
          sortable: true
        },
        {
          variant: 'info',
          key: 'unitBag',
          label: 'ĐVT/Bịch',
          sortable: true
        },
        {
          variant: 'warning',
          key: 'unitSack',
          label: 'ĐVT/Bao',
          sortable: true
        },
        {
          variant: 'warning',
          key: 'quota',
          label: 'Định mức',
          sortable: true
        },
        {
          variant: 'primary',
          key: 'hankBag',
          label: 'Cuộn/bịch',
          sortable: true
        },
        {
          variant: 'primary',
          key: 'hankSack',
          label: 'Cuộn/Bao',
          sortable: true
        },
        {
          variant: 'primary',
          key: 'bagSack',
          label: 'Bịch/Bao',
          sortable: true
        },
        {
          variant: 'primary',
          key: 'elastic',
          label: 'Co giãn',
          sortable: true
        },
        {
          key: 'action'
        }
      ],
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      lastIndexCustomerSelected: 0,
      info: {},
      product: {}
    };
  },
  mounted() {},
  methods: {
    setData(product, productSpecifys) {
      this.lastIndexCustomerSelected = 0;
      this.product = product;
      this.productSpecifys = productSpecifys;
      this.productSpecifysAll = productSpecifys;
      this.$refs['soft-table'].selectRow(this.lastIndexCustomerSelected);
      this.countChecked = 0;
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    addSpecProductUnit(item) {
      if (item) {
        this.productSpecifys.unshift(item);
        this.lastIndexCustomerSelected += 1;
        this.$refs['soft-table'].selectRow(this.lastIndexCustomerSelected);
      }
    },
    handleSearch(keyword) {
      if (keyword == '') {
        this.productSpecifys = this.productSpecifysAll;
      } else {
        this.productSpecifys = this.productSpecifysAll.filter(item => {
          //let keys = Object.keys(item)
          let keysCheck = ['unit'];
          for (let i = 0; i < keysCheck.length; i++) {
            const key = keysCheck[i];
            let value = item[key];
            if (
              value &&
              value
                .toString()
                .toLowerCase()
                .includes(keyword.toLowerCase())
            ) {
              return true;
            }
          }
          return false;
        });
      }
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
      this.$emit('specProductUnitSelected', item);
    },
    tbRowHandleFeatureInfo(item) {
      this.$refs.specFeatureModal.visible = true;
      this.$refs.specFeatureModal.setData(this.product, item);
    },
    tbHandleContextMenuItemClick(a) {
      if (a.menu.key == 'spec_feature') {
        this.$refs.specFeatureModal.visible = true;
        this.$refs.specFeatureModal.setData(this.product, a.data);
      } else if (a.menu.key == 'copy') {
        let newItem = Object.assign({}, a.data);
        delete newItem.id;
        this.$refs.specModal.visible = true;
        this.$refs.specModal.setData(this.product, newItem);
      } else if (a.menu.key == 'edit') {
        this.$refs.specModal.visible = true;
        this.$refs.specModal.setData(this.product, a.data);
      } else if (a.menu.key == 'new') {
        this.handleAddNew();
      } else if (a.menu.key == 'init') {
        this.$refs.productInfoModal.visible = true;
        this.$refs.productInfoModal.setDataFromUnit(this.product, a.data);
      }
    },
    handleEdit() {
      this.$refs.specModal.visible = true;
      this.$refs.specModal.setData(this.product, this.info);
    },
    handleAddNew() {
      this.$refs.specModal.visible = true;
      this.$refs.specModal.setData(this.product, false);
    },
    handleCopy() {},
    handleHelp() {
      alert('help');
    },
    handleDeletes() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.countChecked = items.length;
    }
  }
};
</script>
